import { useDatastoreApi } from '@/composables/use-datastore-api';
import { useSensynIdApi } from './use-sensyn-id-api';
import { useDomainServiceApi } from './use-domain-service-api';

export function useApiClient() {
  function useDomainServiceClient() {
    return useDomainServiceApi();
  }

  function useSensynIdClient() {
    return useSensynIdApi();
  }

  function useDatastoreClient() {
    return useDatastoreApi();
  }

  return { useDatastoreClient, useSensynIdClient, useDomainServiceClient };
}
